/**
 * @desc 报损查询库存明细
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.StockDetailRequestParamsDto>, options?: any) {
  return updateResponse(
    http(URL + `/stockPool/storageDetail`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
